export enum ESidebarTabs {
  UMY = 'UMY',
  QUESTIONS = 'QUESTIONS',
  CONTENT = 'CONTENT',
  MY_NOTES = 'MY_NOTES',
  RESOURCE = 'RESOURCE'
}
